let styles = {
  inboxSubmit: "btn px-4 btn-primary mt-1",
  inboxSuggestResponse: "btn px-4 btn-secondary mt-1"
}

export default styles;